<!--  -->
<template>
  <div class="detection">
    <div class="title">
      <div class="title-text">安全监测</div>
    </div>
    <div class="textbox">
      <span style="margin-right:70px;margin-left:15px">当前园区温度</span>
      <span style="font-size:2.1vh;font-weight: 600;color:#98fef9;margin-right:16px">28°C</span>
    </div>
    <div class="textbox">
      <span style="margin-right:83px;margin-left:15px">异常报警数</span>
      <span style="font-size:2.1vh;font-weight: 600;color:#98fef9;margin-right:16px">5</span>
    </div>
    <div class="bottom">
      <div class="boxitem" style="margin-right:5px">
        <div>烟雾监测</div>
        <div>正常</div>
        <img src="../../assets/yw.png" />
      </div>
      <div class="boxitem">
        <div>漏油监测</div>
        <div>正常</div>
        <img src="../../assets/jyq.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.detection {
  width: 284px;
  height: 21.8vh;
  position: relative;
  left: 6%;
  .textbox {
    margin-top: 1vh;
    width: 263px;
    height: 3.3vh;
    background: url(../../assets/textbox2.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    color: #fff;
    font-family: sy;
    font-size: 0.8vh;
  }
  .bottom {
    display: flex;
    width: 263px;
    margin-top: 2vh;
    .boxitem {
      width: 229px;
      height: 8vh;
      background: url(../../assets/jcbox.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-family: sy;
      font-weight: 600;
      img {
        position: relative;
        left: 83px;
        top: -4vh;
      }
      div {
        &:nth-child(1) {
          color: #fff;
          font-size: 1.1vh;
          margin-top: 1.5vh;
          margin-bottom: 0.6vh;
          margin-left: 5px;
        }
        &:nth-child(2) {
          font-size: 2.2vh;
          color: #98fef9;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>